// extracted by mini-css-extract-plugin
module.exports = {"hasBorder":"ContactForm_hasBorder_2e1JV"};